import React, { useState, useEffect } from "react";
import { Button, Input } from "antd";
import { useDaumPostcodePopup } from "react-daum-postcode";

import * as String from "../commons/string";

export type AddressType = {
    address: string;
    addressDetails: string;
};

function AddressMaker({ value, onChangeAddress: onChangeAddress }: { value?: AddressType; onChangeAddress?: (fullAddress: AddressType) => void }) {
    const open = useDaumPostcodePopup();
    const [firstAddress, setFirstAddress] = useState("");
    const [secondAddress, setSecondAddress] = useState("");

    const handleComplete = (data: any) => {
        let fullAddress = data.address;
        let extraAddress = "";

        if (data.addressType === "R") {
            if (data.bname !== "") {
                extraAddress += data.bname;
            }
            if (data.buildingName !== "") {
                extraAddress += extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
        }
        setFirstAddress(fullAddress);
    };

    const handleClick = () => {
        open({ onComplete: handleComplete, popupTitle: "주소검색" });
    };

    useEffect(() => {
        if (value) {
            setFirstAddress(value.address);
            setSecondAddress(value.addressDetails);
        }
    }, [value]);

    useEffect(() => {
        if (!firstAddress) return;

        if (firstAddress.length > 0) {
            if (onChangeAddress !== undefined)
                onChangeAddress({
                    address: firstAddress,
                    addressDetails: secondAddress,
                });
        }
    }, [firstAddress, secondAddress]);

    return (
        <Input.Group compact>
            <Input
                className="login-input"
                value={firstAddress}
                placeholder={String.address}
                onClick={handleClick}
                onChange={(e) => setFirstAddress(e.target.value)}
            ></Input>
            <Button onClick={handleClick}>{String.search}</Button>
            <Input
                className="login-input"
                value={secondAddress}
                placeholder={String.detailedAddress}
                onChange={(e) => setSecondAddress(e.target.value)}
            />
        </Input.Group>
    );
}

export default AddressMaker;
